import { BranchingOperation } from './types'

export const BranchingOperationsDropdown = [
  { title: 'Is', value: BranchingOperation.Is },
  { title: 'Is Empty', value: BranchingOperation.IsEmpty },
  { title: 'Is Not Empty', value: BranchingOperation.IsNotEmpty }
]

export const indentationColors = [
  '#0A3B9E',
  '#005C99',
  '#0079CC',
  '#3399FF',
  '#66B3FF',
  '#99CCFF'
]

export const BRANCHING_TOOLTIP_TITLE = 'Ensure the prompt is filled and there are no duplicate options before enabling branching'
export const DUPLICATE_TOOLTIP_TITLE = 'Please save the question before duplicating it'
export const FOLLOW_UP_FREE_RESPONSE_QUESTION_TITLE = 'Please save the question before adding a follow-up'
export const DISABLED_FOLLOW_UP_FREE_RESPONSE_QUESTION_TITLE = ''
export const PREFIX_FOLLOW_UP_FREE_RESPONSE_QUESTION_PROMPT = 'Please elaborate on the previous question:'

/** Matches the API validator and `survey_sections.descr` column length. */
export const SECTION_DESCRIPTION_MAX_LENGTH = 1024

export const TEACHING_ROLE_VALUES = {
  PRIMARY_INSTRUCTOR: 'Primary Instructor',
  ADDITIONAL_INSTRUCTOR: 'Additional Instructor',
  TEACHING_ASSISTANT: 'Teaching Assistant'
} as const

export type TeachingRole = typeof TEACHING_ROLE_VALUES[keyof typeof TEACHING_ROLE_VALUES]
export interface TeachingRoleOption {
  value: TeachingRole
  label: string
}

export const TEACHING_ROLE_OPTIONS: TeachingRoleOption[] = [
  { value: TEACHING_ROLE_VALUES.PRIMARY_INSTRUCTOR, label: 'Primary Instructors' },
  { value: TEACHING_ROLE_VALUES.ADDITIONAL_INSTRUCTOR, label: 'Additional Instructors' },
  { value: TEACHING_ROLE_VALUES.TEACHING_ASSISTANT, label: 'Teaching Assistants' }
]

export const TEACHING_ROLE_PRECEDENCE: TeachingRole[] = [
  TEACHING_ROLE_VALUES.PRIMARY_INSTRUCTOR,
  TEACHING_ROLE_VALUES.ADDITIONAL_INSTRUCTOR,
  TEACHING_ROLE_VALUES.TEACHING_ASSISTANT
]

const teachingRolePrecedenceMap = new Map(
  TEACHING_ROLE_PRECEDENCE.map((role, index) => [role, index])
)

// helper function for sorting teaching roles based on predefined precedence
export const sortTeachingRolesByPrecedence = (roles: TeachingRole[]): TeachingRole[] => {
  return [...roles].sort((a, b) => {
    const aOrder = teachingRolePrecedenceMap.get(a) ?? Number.MAX_SAFE_INTEGER
    const bOrder = teachingRolePrecedenceMap.get(b) ?? Number.MAX_SAFE_INTEGER
    return aOrder - bOrder
  })
}

export const sortTeachingRoleOptionsByPrecedence = (roles: TeachingRoleOption[]): TeachingRoleOption[] => {
  return [...roles].sort((a, b) => {
    const aOrder = teachingRolePrecedenceMap.get(a.value) ?? Number.MAX_SAFE_INTEGER
    const bOrder = teachingRolePrecedenceMap.get(b.value) ?? Number.MAX_SAFE_INTEGER
    return aOrder - bOrder
  })
}

export const DEFAULT_REPEAT_PER_INSTRUCTOR_ROLES: TeachingRole[] = [
  TEACHING_ROLE_VALUES.PRIMARY_INSTRUCTOR,
  TEACHING_ROLE_VALUES.ADDITIONAL_INSTRUCTOR
]
